var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 5H11C11.55 5 12 4.55 12 4C12 3.45 11.55 3 11 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H11C11.55 21 12 20.55 12 20C12 19.45 11.55 19 11 19H5V5Z",
    fill: "#394141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.65 11.6496L17.86 8.85955C17.7905 8.7881 17.7012 8.73903 17.6036 8.71862C17.506 8.69821 17.4045 8.70738 17.3121 8.74497C17.2198 8.78255 17.1408 8.84684 17.0851 8.9296C17.0295 9.01237 16.9999 9.10984 17 9.20955V10.9996H10C9.45 10.9996 9 11.4496 9 11.9996C9 12.5496 9.45 12.9996 10 12.9996H17V14.7896C17 15.2396 17.54 15.4596 17.85 15.1396L20.64 12.3496C20.84 12.1596 20.84 11.8396 20.65 11.6496Z",
    fill: "#394141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutImg);
export default __webpack_public_path__ + "static/media/logoutImg.404802f697344870eeeb729a86748ff9.svg";
export { ForwardRef as ReactComponent };